import {HStack, Skeleton} from 'native-base';
import React, {useCallback, useEffect, useState} from 'react';

import {Box} from '@buncha/components/core/view';
import BuyerInfoCell from '../../BuyerInfoCell';
import {Buyers} from '@buncha/itemDetails/types/itemDetails';
import {CustomFlatList} from '@buncha/components/core/list';
import {Dimensions} from 'react-native';
import {useGetBuyersForItemScan} from '@buncha/itemDetails/hooks/ItemScanner';

interface Props {
  runId: number;
  orderItemId: number;
  catalogItemId: number;
}
const BuyersListForScan = (props: Props) => {
  const {runId, orderItemId, catalogItemId} = props;
  const [buyers, setBuyers] = useState<Buyers[]>([]);

  const {getBuyersForItem, loadingBuyer} = useGetBuyersForItemScan();

  const getBuyersHandler = useCallback(async () => {
    if (runId && orderItemId) {
      const buyersResponse = await getBuyersForItem(
        runId,
        orderItemId,
        catalogItemId,
      );
      if (buyersResponse?.length) setBuyers(buyersResponse);
    }
  }, [catalogItemId, getBuyersForItem, orderItemId, runId]);

  useEffect(() => {
    getBuyersHandler();
  }, []);

  const customerTypeString = useCallback((buyer: Buyers) => {
    if (buyer?.hasBunchaClub) return '👑 Buncha Club';
    else if (buyer?.order?.buyer?.isVip) return '👑 VIP Customer';
    else if (buyer?.hasNewCustomer) return 'New Customer';
    return '';
  }, []);

  return (
    <Box>
      <CustomFlatList
        data={buyers}
        showsHorizontalScrollIndicator={false}
        loading={loadingBuyer}
        numOfTimesToRender={1}
        loadingSkeleton={
          <HStack
            space="2"
            alignItems="center"
            style={{
              width: Dimensions.get('screen').width / 1.2,
            }}>
            <Skeleton size="5" rounded="full" />
            <Skeleton h="3" flex="2" rounded="full" />
            <Skeleton h="3" flex="1" rounded="full" startColor="indigo.300" />
          </HStack>
        }
        horizontal
        renderItem={({item}: {item: Buyers}) => {
          return (
            <Box style={{marginRight: 20}}>
              <BuyerInfoCell
                customerType={customerTypeString(item)}
                buyer={item}
                isNSC2Item={item?.isNSC2Item}
                orderItemAttribute={item?.orderItemAttribute}
                isVip={item?.order?.buyer?.isVip}
              />
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default React.memo(BuyersListForScan);
